import { IEmptyTag, SET_EMPTY_TAG } from './types';
import { Dispatch } from 'redux';

export const setEmptyTag = (tag: IEmptyTag) => async (dispatch: Dispatch) => {
  dispatch({ type: SET_EMPTY_TAG, payload: tag });
};
export const deleteEmptyTag = () => async (dispatch: Dispatch) => {
  dispatch({ type: SET_EMPTY_TAG, payload: null });
};
